export const handleStringFilterChange = <T>(
  selectedFilterItems: T[],
  onChange: (newFilterItems: T[]) => void,
  value?: T,
) => {
  if (value !== undefined) {
    const newFilterItems: T[] = selectedFilterItems.some((f) => f === value)
      ? selectedFilterItems.filter((f) => f !== value)
      : [...selectedFilterItems, value];
    onChange(newFilterItems);
  } else {
    onChange([]);
  }
};
